module.exports = __webpack_public_path__ + "img/hand.c43b15f7.svg";